<div class="banner mb-2" *ngIf="showWickedVideo">
  <div class="banner-container">
    <div style="padding: 56.25% 0 0 0; position: relative;">
      <div
        id="wickedvid"
        #wickedvideo
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
      ></div>
      <div class="vimeo-skip-button-container d-none">
        <button
          mat-button
          mat-flat-button
          color="accent"
          (click)="skipVideoPlay($event)"
          class="vimeo-skip-button"
        >
          Skip
        </button>
      </div>
      <div class="skip-top" (click)="skipVideoPlay($event)">
        <img src="skip.png" />
      </div>
    </div>
  </div>
</div>

<div class="homePage position-relative grey-row pt-3 pb-3" [class.no-ads]="isPremium && service.enableSubscription">
  <ng-container *ngIf="service.advService.bannersEnabled">
    <div class="adsContainer" *ngIf="!isPremium || !service.enableSubscription">
      <app-banner-zone-map [zoneType]="'Desktop-Zone-Horizontal-Top'" ></app-banner-zone-map>
    </div>
  </ng-container>

  <div class="container homePage__mainCont mainCont">
    <div class="row m-0 p-0">
      <div class="mainCont__Cites col-xxl-6 col-12 d-none d-lg-block white-row p-3">
        <h5>Popular Cities</h5>
        <div class="row m-0 d-flex" style="min-height: 500px;">
          <div
            class="col-md-6 col-lg-3 col-sm-12 mb-2 front-list-font"
            *ngFor="let city of mostPopularCities | async"
          >
            <a [routerLink]="getCityUrl(city)">{{ city.name }}</a>
          </div>
        </div>
      </div>
      <div class="mainCont__LongCats col-xxl-3 col-6">
        <div class="w-100 white-row p-3">
          <h5>Casual Dating</h5>
          <div class="mb-2 front-list-font" *ngFor="let category of categories">
            <div class="w-100">
              <a [routerLink]="getCategoryUrl(category, true)" (click)="goToCategoryUrl($event, category, true)">{{ category.name }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="mainCont__TermCats col-xxl-3 white-row col-6 pr-3" [ngClass.gt-lg]="'pl-3'">
        <div class="box w-100 p-3">
          <h5>Long Term Relationships</h5>
          <div class="mb-2 front-list-font" *ngFor="let category of categories">
            <div class="w-100">
              <a [routerLink]="getCategoryUrl(category, false)" (click)="goToCategoryUrl($event, category, false)">{{ category.name }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container
    *ngIf="service.advService.bannersEnabled"
  >
    <div class="adsContainer" *ngIf="!isPremium || !service.enableSubscription">
      <app-banner-zone-map
        [zoneType]="'Desktop-Zone-Horizontal-Bottom'"
      ></app-banner-zone-map>
    </div>

    <div
      class="adsContainer adsContainer__vertical adsContainer__vertical--left"
      *ngIf="!isPremium || !service.enableSubscription"
    >
      <app-banner-zone-map
        [zoneType]="'Desktop-Zone-Vertical-Left'"
      ></app-banner-zone-map>
    </div>

    <div
      class="adsContainer adsContainer__vertical adsContainer__vertical--right"
      *ngIf="!isPremium || !service.enableSubscription"
    >
      <app-banner-zone-map
        [zoneType]="'Desktop-Zone-Vertical-Right'"
      ></app-banner-zone-map>
    </div>
  </ng-container>
</div>
